export interface EnrollmentSummary {
  enrollmentAckDate: string;
  enrollmentId: number;
  enrollmentStatus: string;
  recentOptOutDate: string;
  waitingPeriodEndDate?: string;
}
